import { App } from '@web/query/App';
import { ProductFruitsInitialize } from './ProductFruitsInitialize';

const ProductFruits = () => {
  const { data: features } = App.useFeatures();

  if (features?.product_fruits) {
    return <ProductFruitsInitialize />;
  }

  return null;
};

export { ProductFruits };
